const sanitizeLangText = (text, isSpanTagAllowed = false) => {
  if (text) {
    text = text.replace(/(<br ?\/>)/ig, '');
    text = text.replace(/(<\/?p>)/ig, '');
    text = text.replace('<span class="required-field">*</span>', '');

    let chineseText;
    const chineseTagStart = text.indexOf('<span class="chineseTranslations">');

    if (chineseTagStart !== -1) {
      const chineseTagEnd = text.indexOf('</span>', chineseTagStart);
      chineseText = text.slice(chineseTagStart + 34, chineseTagEnd);
      chineseText = chineseText.replace(/(<span\/?>)/ig, '');
      text = text.slice(0, chineseTagStart);
    }
    text = text.replace(/(<\/?span>)/ig, '');

    if (chineseText) {
      if (isSpanTagAllowed) {
        return (
          <span>
            {text}
            <br />
            {chineseText}
          </span>
        );
      }
      return `${text} | ${chineseText}`;
    }
  }

  return text;
};

export default sanitizeLangText;
